import Footer from "../../../components/Footer";
import Loader from "../../../components/Loader";
import Helmet from "react-helmet";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import styles from "./TechnicianMaintenanceRequests.module.css";
import RequestFilter from "./components/Filter";
import RequestListing from "./components/listing";
import { Typography, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ChevronLeft, Home } from "react-feather";
import axios from "axios";
import RequestDetails from "./components/requestDetails";

const TechnicianMaintenanceRequests = () => {
  const { getAccessTokenSilently, user } = useAuth0();

  const [loading, setLoading] = useState(true);
  const [contentLoading, setContentLoading] = useState(true);
  const [requestList, setRequestList] = useState([]);
  const [allRequest, setAllRequest] = useState([]);
  const [maintenanceDetails, setMaintenanceDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    searchKey: "",
    priority: "",
    assignee: "",
    status: "",
  });

  useEffect(() => {
    getRequestList();
  }, [getAccessTokenSilently]);
  const getRequestList = async () => {
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    axios(
      process.env.REACT_APP_CASE_API_URL + "v1/technician/maintenance-requests",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        setContentLoading(false);
        setLoading(false);
        let allDataTemp = response?.data.data?.map((item) => {
          if (item?.sub_category === "Electrical Socket")
            return { ...item, image: "/static/img/ElectricalSocket.svg" };
          if (item?.sub_category === "Light Switch/Dimmer")
            return { ...item, image: "/static/img/Dimmer.svg" };
          if (item?.sub_category === "Mount Television")
            return { ...item, image: "/static/img/tv.svg" };
          if (item?.sub_category === "Leak")
            return { ...item, image: "/static/img/Leak.svg" };
          if (item?.sub_category === "Drain Clogged")
            return { ...item, image: "/static/img/DrainClogged.svg" };
          if (item?.sub_category === "Water Temperature Issue")
            return { ...item, image: "/static/img/WaterTemperature.svg" };
          if (item?.sub_category === "Heating & Cooling System")
            return { ...item, image: "/static/img/heat&cool.svg" };
          if (item?.sub_category === "Stove/Oven Issue")
            return { ...item, image: "/static/img/StoveOven.svg" };
          if (item?.sub_category === "Refrigerator Issue")
            return { ...item, image: "/static/img/Refrigerator.svg" };
          if (item?.sub_category === "Washer/Dryer Issue")
            return { ...item, image: "/static/img/Washer.svg" };
          if (item?.sub_category === "Other Issue")
            return { ...item, image: "/static/img/other.svg" };
          return { ...item, image: "/static/img/other.svg" };
        });
        setAllRequest(allDataTemp);
      })
      .catch(() => {
        setContentLoading(false);
      });
  };

  useEffect(() => {
    if (allRequest.length > 0) {
      let filteredDataTemp = allRequest;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        filteredDataTemp = filteredDataTemp.filter((item) => {
          return (
            item?.title.toLowerCase().includes(inputVal) ||
            item?.property_name.toLowerCase().includes(inputVal) ||
            item?.apt_name.toLowerCase().includes(inputVal) ||
            item?.tenant_name.toLowerCase().includes(inputVal)
          );
        });
      }

      if (filterData.status && filterData.status !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => {
          return i.current_status === Number(filterData.status);
        });
      }

      if (filterData.priority && filterData.priority !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => {
          return i.priority === Number(filterData.priority);
        });
      }
      if (filterData.assignee && filterData.assignee !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => {
          return i.assignee_id === user?.sub;
        });
      }

      setRequestList(filteredDataTemp);
    }
  }, [allRequest, filterData]);

  const [addFormOpen, setAddFormOpen] = useState(false);

  useEffect(() => {
    if (!isModalOpen) {
      setMaintenanceDetails(null);
      getRequestList();
    }
  }, [isModalOpen]);

  const setDetails = (details) => {
    if (details) {
      setMaintenanceDetails(details);
      getMaintenanceDetails(details.id);
    }
  };

  const getMaintenanceDetails = async (id) => {
    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    axios(
      process.env.REACT_APP_CASE_API_URL +
      "v1/technician/maintenance-requests/" +
      id,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        setContentLoading(false);
        setLoading(false);
        let item = response?.data.data;

        let updatedItem = { ...item, image: "/static/img/other.svg" };

        if (item?.sub_category === "Electrical Socket")
          updatedItem.image = "/static/img/ElectricalSocket.svg";
        else if (item?.sub_category === "Light Switch/Dimmer")
          updatedItem.image = "/static/img/Dimmer.svg";
        else if (item?.sub_category === "Mount Television")
          updatedItem.image = "/static/img/tv.svg";
        else if (item?.sub_category === "Leak")
          updatedItem.image = "/static/img/Leak.svg";
        else if (item?.sub_category === "Drain Clogged")
          updatedItem.image = "/static/img/DrainClogged.svg";
        else if (item?.sub_category === "Water Temperature Issue")
          updatedItem.image = "/static/img/WaterTemperature.svg";
        else if (item?.sub_category === "Heating & Cooling System")
          updatedItem.image = "/static/img/heat&cool.svg";
        else if (item?.sub_category === "Stove/Oven Issue")
          updatedItem.image = "/static/img/StoveOven.svg";
        else if (item?.sub_category === "Refrigerator Issue")
          updatedItem.image = "/static/img/Refrigerator.svg";
        else if (item?.sub_category === "Washer/Dryer Issue")
          updatedItem.image = "/static/img/Washer.svg";
        else if (item?.sub_category === "Other Issue")
          updatedItem.image = "/static/img/other.svg";

        setMaintenanceDetails(updatedItem);
      })

      .catch(() => {
        setContentLoading(false);
      });
  };

  const updateMaintenanceDetails = () => {
    if (maintenanceDetails) {
      getMaintenanceDetails(maintenanceDetails.id);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Helmet title="Requests" />
      <div className={`${styles.pageTitleWrap}`}>
        <Typography display="inline" className={`${styles.pageTitle}`}>
          Requests
        </Typography>
        <nav aria-label="breadcrumb">
          <ol className={`${styles.breadcrumb}`}>
            <li className={`${styles.breadcrumbItem}`}>
              <span>
                <Home />
              </span>
              Requests
            </li>
            <li className={`${styles.breadcrumbItem} ${styles.active}`}>
              Maintenance
            </li>
          </ol>
        </nav>
      </div>

      <div className={`${styles.BodyCon}`}>
        <div className={`${styles.mainCardDiv}`}>
          <div className={`${styles.mainCard}`}>
            <div className="control-pane">
              <div className={`${styles.Row}`}>
                <RequestFilter
                  setFilterData={setFilterData}
                  filterData={filterData}
                />

                <RequestListing
                  requestList={requestList}
                  setIsModalOpen={setIsModalOpen}
                  setDetails={setDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Dialog
        open={isModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button
            className={`${styles.BackAddBU}`}
            onClick={() => setIsModalOpen(false)}
          >
            <ChevronLeft />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <RequestDetails
            maintenanceDetails={maintenanceDetails}
            updateMaintenanceDetails={updateMaintenanceDetails}
            setLoading={setLoading}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withAuthenticationRequired(TechnicianMaintenanceRequests, {
  onRedirecting: () => <Loader />,
});
